export const errorStore = {};
export const resetErrorStore = () => Object.keys(errorStore).forEach((key) => delete errorStore[key]);
export const getServiceErrorByCode = (code) => errorStore[code];
//# sourceMappingURL=stores.js.map